import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, of } from "rxjs";
import { catchError, filter, map } from 'rxjs/operators';
import { CompanyService } from "src/app/core/services/company/company.service";
import { environment } from '../environments/environment';
import { IContribuyente } from "./core/models/business-information/ibusiness-information";
import { AuthResponse } from './core/models/user/ciam-auth';
import { CiamUser } from './core/models/user/ciam-user';
import { IUser } from './core/models/user/user';
import { FormatDocumentTypePipe } from "./core/pipes/format-documant-type/format-document-type.pipe";
import { LocalStorageService } from "./core/services/local-storage/local-storage.service";
import { SesionStorageService } from './core/services/sesion-storage/sesion-storage.service';
import { GlobalService } from './core/services/global/global.service';
import { UserService } from './core/services/user/user.service';
import { jwtDecode } from 'jwt-decode';
import { FeatureFlagService } from "./core/services/api/feature-flag.service";
import { TealiumService } from './tealium/TealiumService';

declare var dataLayer;

declare global {
  interface Window {
    CiamActiveDirectory: any;
    dataLayer: any[];
  }
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  isMobile: boolean = false;
  lastChange: string = '';
  title = 'Portal Empresas';
  mostrarContenido = false;
  showContent: boolean = false;
  isLoading: boolean = false;
  currentYear!: number;
  public business: IContribuyente;
  public companyData: IContribuyente;
  public $companyData: Observable<IContribuyente>;
  private apiKey: string;
  private typeMarketing: string;
  private varUserdata: string;
  private screenPrefix: string;
  private cdnUrl: string;
  private urlAuthenticationCiam: string;
  private countAuth: number;

  constructor(
    private _company: CompanyService,
    private _router: Router,
    private formatDocumentTypePipe: FormatDocumentTypePipe,
    private _STORAGE: LocalStorageService,
    private _sesionStorage: SesionStorageService,
    private globalService: GlobalService,
    private userService: UserService,
    private featureFlagService: FeatureFlagService,
    private tealiumService: TealiumService
  ) {
    this.apiKey = environment.CIAM_API_KEY;
    this.typeMarketing = environment.CIAM_TYPE_MARKETING;
    this.varUserdata = environment.CIAM_VAR_USERDATA;
    this.screenPrefix = environment.CIAM_API_PREFIX;
    this.cdnUrl = environment.CIAM_API_CDN_URL;
    this.urlAuthenticationCiam = environment.CIAM_URL_AUTHENTICATION_CIAM;
    this.countAuth = Number(environment.CIAM_COUNT_AUTH) || 4;
    this.tealiumService.init(environment.TEALIUM.CUENTA , environment.TEALIUM.PERFIL, environment.TEALIUM.ENTORNO);
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.tealiumService.trackView({
        page_url: event.urlAfterRedirects,
        page_type: 'spa_navigation'
      });
    });
  }

  ngOnInit() {
    this.featureFlagService.cargarFeaturesFlags();
    this.currentYear = new Date().getFullYear();
    const ciamConfig = {
      apiKey: this.apiKey,
      cdnUrl: this.cdnUrl,
      typeMarketing: this.typeMarketing,
      varUserdata: this.varUserdata,
      screenPrefix: this.screenPrefix,
      urlAuthenticationCiam: this.urlAuthenticationCiam,
      countAuth: this.countAuth,
      showLogout: true, // o true, según quieras
      showRegister: false,
      redirectLogin: (success: boolean) => {
        // Este callback se dispara cuando la librería termina la autenticación
        // Equivale al (result_auth)="responseLoginCiam($event)"
        //this.responseLoginCiam(success);
        this.redirectUrl(success);
      },
    };

    // Instanciar la clase:
    const ciamInstance = new window.CiamActiveDirectory(ciamConfig);
    this.sendHitGoogleAnalytics();

    this.business = this._STORAGE.parseItem('businessInformation');
    if (this.business !== null) {
      const docType = `${this.formatDocumentTypePipe.transform(this.business.tipoDocumento)}`;
      const docNumber = `${this.business.numeroDocumento}`;
      const state = `1`;
      const isRectificable = true;
    }

    this.checkWindowSize();
    this.globalService.validarVersion();
  }

  responseLoginCiam(resp: boolean): void {
    if (resp) {
      this.isLoading = true;
      const jwt = localStorage.getItem("sso_empresa");
      this.userService.verifyTokenCIAM(jwt).subscribe(
        (validToken) => {
          if (validToken) {
            const data = jwtDecode(jwt);
            localStorage.setItem("jw_token", JSON.stringify(data));
            localStorage.setItem("token", jwt);
            setTimeout(() => (this.isLoading = false), 1000);
            setTimeout(() => {
              window.location.href = environment.URL_CONTEXT + '/#/';
              this.showContent = resp;
            }, 3000);
          } else {
            localStorage.clear();
            window.location.href = environment.URL_CONTEXT + '/#/login';
            window.location.reload();
          }
        },
        (error) => {
          localStorage.clear();
          window.location.href = environment.URL_CONTEXT + '/#/login';
          window.location.reload();
        }
      );
    }
  }

  sendHitGoogleAnalytics() {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        dataLayer.push({
          event: 'pageview',
          page: {
            page: event.url
          }
        });
      })
    ).subscribe();
  }

  get varUserData() {
    return environment.CIAM_VAR_USERDATA;
  }

  redirectUrl(redirect: boolean) {
    if (redirect) {
      setTimeout(() => {
        console.log('login ciam');
        this.loadCIAM();
      }, 1000);
    } else {
      console.log('logout ciam');
      //  this._router.navigate(['/login']);
    }
  }

  loadCIAM() {
    let dataCompany = this._sesionStorage.getItemJSON(environment.CIAM_VAR_ORGANIZATION);
    let dataSessionAut: AuthResponse = this._STORAGE.getItemJSON(environment.CIAM_VAR_AUTHDATA);
    let dataSession: CiamUser = this._sesionStorage.getItemJSON(environment.CIAM_VAR_USERDATA);

    if (dataSession) {
      console.log('Usuario autenticado.');
      let userloggedin: IUser = {};
      const numeroDocumento = dataCompany.info.numeroDocumento[0];
      const tpIdentificacion = this.transformarIdentificacion(dataCompany.info.tpIdentificacion[0]);
      const correos = Array.isArray(dataSession.data.Correo)
        ? dataSession.data.Correo
        : [dataSession.data.Correo];

      const correoEmpresaSeleccionada = correos.find(
        correo => correo.BpID === dataCompany.bpid
      );

      userloggedin.docNumberCompany = numeroDocumento;
      userloggedin.docTypeCompany = tpIdentificacion;

      userloggedin.docNumberCustomer = dataSessionAut.business.docNumberCustomer;
      userloggedin.docTypeCustomer = dataSessionAut.business.docTypeCustomer;

      userloggedin.firstName = dataSessionAut.business.firstName;
      userloggedin.lastName = dataSessionAut.business.lastName;
      userloggedin.fullName = dataSessionAut.business.fullName;
      userloggedin.telephoneNumber = dataSessionAut.business.telephoneNumber;
      userloggedin.email = correoEmpresaSeleccionada?.DireccionCorreo ?? dataSessionAut.business.email;

      userloggedin.checkDigit = this.calcularDigitoVerificacion(userloggedin.docNumberCompany, userloggedin.docTypeCompany);

      userloggedin.timeSession = dataSessionAut.business.timeSession;
      userloggedin.tokenId = dataSessionAut.business.tokenId;

      this._STORAGE.setItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN, userloggedin);
      this._STORAGE.setItem(environment.LOCAL_STORAGE.AUTHORIZATION_TOKEN, dataSessionAut.access_token);
      this._STORAGE.setItem(environment.LOCAL_STORAGE.LOGIN_USER_TOKEN, this._STORAGE.getItemString(environment.CIAM_VAR_USERDATA));
      this.getBusinnessInformation();
    }
  }


  getCiamAuthInfo() {
    return this._STORAGE.parseItem<AuthResponse>(environment.CIAM_VAR_AUTHDATA);
  }

  redirigirATablero() {
    const baseUrl = window.location.origin;
    const redirectPath = environment.URL_CONTEXT + '/#/';
    const fullRedirectUrl = baseUrl + redirectPath;

    window.location.href = fullRedirectUrl;
  }

  getBusinnessInformation() {
    console.log('getBusinnessInformation');
    let userloggedin: IUser = this._STORAGE.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this._company
      .getBusinnessInformation(
        userloggedin.docTypeCompany,
        userloggedin.docNumberCompany,
        userloggedin.checkDigit
      )
      .pipe(
        map((response: any) => {
          this.companyData = response.body.data[0].contribuyente;
          this._company.setBusinnessInformation(this.companyData);
          this.$companyData = this._company.getBusinnessInformationObs();
          this._STORAGE.stringifyItem(
            environment.LOCAL_STORAGE.BUSINESS_INFORMATION,
            this.companyData
          );
          this.mostrarContenido = true;
          this.redirigirATablero();
        }),
        catchError((error: Error) => {
          console.error('Error al obtener la información de la empresa:', error.message);
          this.mostrarContenido = true;
          this.redirigirATablero();
          return of(null);
        })
      )
      .subscribe();
  }

  handleStorageChange() {
    console.log('handleStorageChange');
    setTimeout(() => {
      console.log('handleStorageChange start');
      let userloggedin: IUser = this._STORAGE.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
      let dataSession: CiamUser = this._sesionStorage.getItemJSON(environment.CIAM_VAR_USERDATA);
      if (dataSession) {
        if (userloggedin) {

        } else {
          if (this.checkIfDialogIsVisible() === false) {
            window.location.reload();
            console.log('Redireccionar');
          }
        }

      }
    }, 3000);
  }

  checkIfDialogIsVisible(): boolean {
    const element = document.querySelector('.gigya-screen-dialog-main');
    if (element) {
      const style = window.getComputedStyle(element);
      const isVisible = style.display !== 'none' && style.visibility !== 'hidden';
      console.log('¿Es visible?:', isVisible);
      return isVisible;
    }

    return false;
  }


  transformarIdentificacion(tipoIdentificacion) {
    switch (tipoIdentificacion) {
      case 'NI':
        return '1';
      case 'CC':
        return '2';
      case 'CE':
        return '3';
      case 'TI':
        return '4';
      case 'RC':
        return '5';
      case 'CD':
        return '6';
      case 'PA':
        return '7';
      case 'PE':
        return '8';
      case 'PT':
        return '9';
      default:
        return '0';
    }
  }


  calcularDigitoVerificacion(docNumber: string, docType: string) {
    if (docType === '1') {
      // Verificar si el docNumber es '1' y tiene una longitud de 10
      if (docNumber.length === 10) {
        const ultimoCaracter = docNumber.charAt(docNumber.length - 1);
        // Aquí podrías hacer algo con el último carácter si es necesario
        return ultimoCaracter;
      }

      // Si no es el caso, calcular el dígito de verificación
      return this.calcularDV(docNumber);
    }

    return '';
  }

  calcularDV(nit: any): string {
    // Se limpia el Nit
    nit = nit.replace(/\s/g, ''); // Espacios
    nit = nit.replace(/,/g, ''); // Comas
    nit = nit.replace(/\./g, ''); // Puntos
    nit = nit.replace(/-/g, ''); // Guiones

    const vpri = new Array(16);
    let z = nit.length;

    vpri[1] = 3;
    vpri[2] = 7;
    vpri[3] = 13;
    vpri[4] = 17;
    vpri[5] = 19;
    vpri[6] = 23;
    vpri[7] = 29;
    vpri[8] = 37;
    vpri[9] = 41;
    vpri[10] = 43;
    vpri[11] = 47;
    vpri[12] = 53;
    vpri[13] = 59;
    vpri[14] = 67;
    vpri[15] = 71;

    let x = 0;
    let y = 0;

    for (let i = 0; i < z; i++) {
      y = nit.slice(i, i + 1);
      x += y * vpri[z - i];
    }

    y = x % 11;
    let dv = y > 1 ? 11 - y : y;
    return dv.toString();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkWindowSize();
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth <= 768;
  }


}
